import { getIcon } from '@flybits/design-system';
import React from 'react';
import { EVENT_KEYS } from 'types/events';
import './TemplateCard.scss';

type TemplateCardProps = {
  key?: string;
  className?: string;
  title?: string;
  onSelect: () => void;
  overlay?: React.ReactNode;
  imageUrl?: string;
  accessibilityText?: string;
  defaultText?: string;
  isLoading?: boolean;
  isSelected?: boolean;
  selectOnClick?: boolean;
};

const DEFAULT_CLASS = 'template-card';

/**
 * Template tile. The full-page library selects on Enter only, while the modal
 * passes `selectOnClick` so a click marks the card as the chosen template.
 */
const TemplateCard: React.FC<TemplateCardProps> = ({
  title = '',
  defaultText = '',
  onSelect,
  imageUrl,
  overlay,
  className,
  isLoading,
  accessibilityText = '',
  isSelected = false,
  selectOnClick = false,
}) => {
  let mainClass = DEFAULT_CLASS;
  mainClass += className ? ` ${className}` : '';
  if (isSelected) {
    mainClass += ` ${DEFAULT_CLASS}--selected`;
  }

  const getRandomColor = () => `hsl(${360 * Math.random()},${25 + 70 * Math.random()}%,${85 + 10 * Math.random()}%)`;

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === EVENT_KEYS.ENTER) {
      event.preventDefault();
      onSelect();
    }
  };

  return (
    <div
      className={mainClass}
      onClick={selectOnClick ? onSelect : undefined}
      onKeyDown={onKeyDown}
      role="button"
      tabIndex={0}
      aria-label={accessibilityText}
      aria-pressed={isSelected}
    >
      {isLoading ? (
        <div className={`${DEFAULT_CLASS}__container`}>
          <div className={`${DEFAULT_CLASS}__container__mid`}>
            <div className={`${DEFAULT_CLASS}__container__mid__loading`}>{getIcon('loading', {})}</div>
          </div>
        </div>
      ) : null}
      {overlay ? <div className={`${DEFAULT_CLASS}__overlay`}>{overlay}</div> : null}
      {imageUrl ? (
        <div className={`${DEFAULT_CLASS}__image`}>
          <img className={`${DEFAULT_CLASS}__cards__card__img`} src={imageUrl} alt="" />
        </div>
      ) : null}
      {!imageUrl && defaultText ? (
        <div className={`${DEFAULT_CLASS}__image`} style={{ backgroundColor: getRandomColor() }}>
          {defaultText}
        </div>
      ) : null}
      {title ? <div className={`${DEFAULT_CLASS}__body`}>{title}</div> : null}
    </div>
  );
};

export default TemplateCard;
